import React, { useState, Component } from 'react';
import {Link} from 'react-router-dom';

import ExternalMedia from './externalmedia';

function Tutorials() {

    return (
             <div className="mainContentWrapper">

                <div className="contentContainer">

                      
                        <ExternalMedia
                            title="Einführungsvideo"
                            iframeSrc="https://www.youtube-nocookie.com/embed/msZjHwJY2DQ?si=JkY4-QFbwrqDoZDU"
                        
                        />

                        <br/>
                        
                        <ExternalMedia
                            title="Terminauftrag"
                            iframeSrc="https://www.youtube-nocookie.com/embed/nuf14M5BCrs?si=DnuebYj_zyTuTgwU"
                            
                        />

                        <br/>
                        <ExternalMedia
                            title="Vorlagen verwalten"
                            iframeSrc="https://www.youtube-nocookie.com/embed/omPZ71fPFYY?si=mzwoAfapRU7g7ds8"
                        
                        />

                        <br/>
                        <ExternalMedia
                            title="Reizpartien und Freistücke"
                            iframeSrc="https://www.youtube-nocookie.com/embed/tn93dHsIVI4?si=wzrkJOCN0M01fhdT"
                        
                        />
                </div>
            </div> 
                 
            );
}

export default Tutorials;



